// extracted by mini-css-extract-plugin
var _1 = "L_kxw";
var _2 = "nZ_qG";
var _3 = "JwqKF";
var _4 = "Smi6d";
export { _1 as "includedServices", _2 as "link", _3 as "serviceList", _4 as "title" }
